export default {
  middleware_url: "https://archives.v2.livraisons.pro",
  cake_url: "https://archives.cake.v2.livraisons.pro",
  isWavesoftEnabled: false,
  isUrbantzEnabled: false,
};
